import * as React from "react";
import styled from "styled-components/macro";
import { Power } from "react-feather";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { Tooltip, IconButton as MuiIconButton } from "@mui/material";

import { connect } from "react-redux";
import { logout } from "../../actions/AuthActions";

const IconButton = styled(MuiIconButton)`
  svg {
    width: 22px;
    height: 22px;
  }
`;

function NavbarUserDropdown({ logout }) {
  const [anchorMenu] = React.useState(null);

  const navigate = useNavigate();

  const handleSignOut = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <React.Fragment>
      <Tooltip title="Signout">
        <IconButton
          aria-owns={Boolean(anchorMenu) ? "menu-appbar" : undefined}
          aria-haspopup="true"
          onClick={handleSignOut}
          color="inherit"
          size="large"
        >
          <Power />
        </IconButton>
      </Tooltip>
    </React.Fragment>
  );
}

NavbarUserDropdown.propTypes = {
  logout: PropTypes.func.isRequired,
  auths: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auths: state.auths,
});

export default connect(mapStateToProps, { logout })(NavbarUserDropdown);
